/**
 * ContactPoint type
 * DOC: https://schema.org/ContactPoint
 */

export default ({
  contactType,
  email,
  url
}) => ({
  '@type': 'ContactPoint',
  ...(contactType && {
    contactType
  }),
  ...(email && {
    email
  }),
  ...(url && {
    url
  })
});